var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFolder2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 7.37964V11.0996C14.6663 13.0663 13.0663 14.6663 11.0997 14.6663H4.89967C2.93301 14.6663 1.33301 13.0663 1.33301 11.0996V6.29297H14.493C14.593 6.59297 14.6463 6.89964 14.6597 7.2263C14.6663 7.27297 14.6663 7.33297 14.6663 7.37964Z",
    fill: "#9B97A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.493 6.29301H1.33301V4.27967C1.33301 2.65301 2.65301 1.33301 4.27967 1.33301H5.83301C6.91967 1.33301 7.25967 1.68634 7.69301 2.26634L8.62634 3.50634C8.83301 3.77967 8.85967 3.81967 9.24634 3.81967H11.1063C12.6863 3.81301 14.033 4.85301 14.493 6.29301Z",
    fill: "#9B97A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder2);
export default __webpack_public_path__ + "static/media/icon-folder-2.6c42394a86c8fc5863bc89cd850e8cb1.svg";
export { ForwardRef as ReactComponent };